var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14978 1.44987L6.95978 2.88987L4.49378 3.80787L6.95978 4.72587L6.13178 6.20187L4.07978 4.58188L4.45778 7.19187H2.80178L3.14378 4.58188L1.09178 6.23787L0.227781 4.70787L2.67578 3.78987L0.227781 2.90787L1.05578 1.43187L3.16178 3.05187L2.80178 0.423874H4.47578L4.07978 3.05187L6.14978 1.44987Z",
    fill: "#F0B64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.426b0350b0b23f290a619422c89cc557.svg";
export { ForwardRef as ReactComponent };